import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import {userType} from "../../shared/utils/enums";

export const candidateGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if(auth.user) {
    if (auth.user.kind !== userType.candidat) {
      router.navigateByUrl('/login')
    }
    return auth.user.kind == userType.candidat;
  }
  router.navigateByUrl('/login')
  return false;
};
